import { render, staticRenderFns } from "./BudgetNoteTemplateModal.vue?vue&type=template&id=67b718e7&scoped=true&"
import script from "./BudgetNoteTemplateModal.vue?vue&type=script&lang=js&"
export * from "./BudgetNoteTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetNoteTemplateModal.vue?vue&type=style&index=0&id=67b718e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b718e7",
  null
  
)

export default component.exports